import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import './config/firebase';
import EnrolmentForm from './components/EnrolmentForm';
import Success from './components/Success';
import ErrorMessage from './components/Error';
import ListEnrolments from './components/ListEnrolments';

function App() {
    return (
        <Router>
            <div className="App">
                <header className="App-header">CFBS Registrations</header>
                <Routes>
                    <Route path="/" element={<EnrolmentForm />} />
                    <Route path="/success" element={<Success />} />
                    <Route path="/error" element={<ErrorMessage />} />
                    <Route
                        path="/list-registrations"
                        element={<ListEnrolments />}
                    />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
